<template>
  <generic-triangle-print
    :type="polygonalChartType"
    :data="data"
    :norm="norm"
    :coordinates="triangleCoordinates">
    <template v-if="hasSomeValue" #coordinates>
      %C₂H₆ = {{ formatNumberValue(data.data.percentageC2H6) }} |
      %C₂H₄ = {{ formatNumberValue(data.data.percentageC2H4) }} |
      %CH₄ = {{ formatNumberValue(data.data.percentageCH4) }}
    </template>
    <template v-else #coordinates>
      -
    </template>
  </generic-triangle-print>
</template>

<script>
import polygonalChartTypes from '@/domain/enums/polygonalCharts/polygonalChart';
import duvalTriangleCoordinates from '@/domain/services/installation/engineering/chromatography/duvalTriangleCoordinates';
import GenericTrianglePrint from './GenericTriangle';

export default {
  name: 'Triangle5',
  props: {
    data: Object,
    norm: String,
  },
  components: {
    GenericTrianglePrint,
  },
  data: () => ({
    polygonalChartType: polygonalChartTypes.DUVAL_TRIANGLE_5,
  }),
  computed: {
    triangleCoordinates() {
      return duvalTriangleCoordinates
        .getTriangle5Coordinates(this.data.data);
    },
    hasSomeValue() {
      return this.data.data.percentageC2H6
        || this.data.data.percentageC2H4
        || this.data.data.percentageCH4;
    },
  },
  methods: {
    formatNumberValue(value) {
      if (typeof value !== 'number') {
        return value;
      }
      return this.$n(value, { minimumFractionDigits: 1, maximumFractionDigits: 1 });
    },
  },
};

</script>
